export const desktop_logo_width = 91.8;
export const desktop_logo_height = 18;
export const mobile_logo_width = 76.5;
export const mobile_logo_height = 15;

export const order_history_path = '/order-history';

export const internal_path = '/hjovueg7zyfjtzo';

export const ban_home_link = 'https://www.porter.com.bd';
export const tur_home_link = 'https://theporter.com.tr';

export const ga_mobile_menu_open = 'Hamburger Menu Click';
export const ga_header_event_prefix = 'Header';

export const logout_button = 'Logout';
export const live_orders_text = 'Live Orders';
export const track_order = 'Track Order';
export const track_order_live = 'Live';
